import { render } from "./IconStreamsEmptyPlaceholderImage.vue?vue&type=template&id=9e7fb8de"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconStreamsEmptyPlaceholderImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e7fb8de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e7fb8de', __exports__)) {
    api.reload('9e7fb8de', __exports__)
  }
  
  module.hot.accept("./IconStreamsEmptyPlaceholderImage.vue?vue&type=template&id=9e7fb8de", () => {
    api.rerender('9e7fb8de', render)
  })

}


export default __exports__